import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import CustomDropDown from './CustomDropDown';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { AutoComplete } from 'antd';
import { getData } from '../../../services/ApiCallingUserServices';
import { encryptUrlDatapattern } from '../../../components/commonClass/EncFunc';
import { formatDateddmmyyy, formatDateyyyymmdd, HotelResponseTime } from '../../../components/commonClass/CommonValidation';
import { DayPickerRangeController } from 'react-dates';

const FilterFormHotels = ({isdisabled}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [homeData, setHomeData] = useState([]);
    const [formError, setFormError] = useState({})
    const [totalNoOfRooms, setTotalNoOfRooms] = useState(1);

    const [focusedInput, setFocusedInput] = useState('startDate');
    const [calendarOpen, setCalendarOpen] = useState(false)

    const [form, setForm] = useState(
        {
            CheckIn: null,
            CheckOut: null,
            HotelCodes: '',
            GuestNationality: "IN",
            PaxRooms: [
                {
                    Adults: 1,
                    Children: 0,
                    ChildrenAges: []
                }
            ],
            ResponseTime: HotelResponseTime,
            IsDetailedResponse: true,
            Filters: {
                Refundable: false,
                NoOfRooms: 0,
                MealType: 0,
                OrderBy: 0,
                StarRating: 0,
                HotelName: null
            },
            CityCode: 0,
            CityName: '',
            isHotel: null,
            isExplore: true,
        })

    const timeoutIdRef = useRef(null);
    const debounce = (func, delay) => {
        return (...args) => {
            if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const getdropdownData = debounce(async (text) => {
        await getData(`/customerui/v1/gethotelsearchbytext?searchText=${text}`)?.then((rep) => {
            let city = rep?.data?.tboHotelCityList?.map((el) => ({
                CityName: el.CityName,
                CityCode: el.CityCode,
                isHotel: false
            }));
            let hotel = rep?.data?.tboHotelList?.map((el) => ({
                CityName: el.HotelName,
                CityCode: el.HotelCode,
                isHotel: true
            }));
            let hotelandcitySection = [
                ...city,
                ...hotel
            ]
            rep.data.tboHotelCityList = hotelandcitySection
            setHomeData(
                rep?.data?.tboHotelCityList
            )
            // dispatch(loaderActions.end());
        })
    }, 300)

    const handleChange = (name, e) => {
        setFormError({});
        const value = e;
        if (value) {
            if (name === 'CityName') {
                setForm({ ...form, [name]: value, CityCode: 0, isHotel: null })
                if (value?.length >= 3) {
                    getdropdownData(value)
                }
                else {
                    setHomeData([])
                }
            }
        }
        else {
            if (name === 'CityName') {
                setForm({ ...form, [name]: value, CityCode: 0, isHotel: null })
                setHomeData([])
            }
        }
    }

    const onChange = (name, val, roomindex, ageindex) => {
        if (name === "NoOfRooms") {
            let rooms = [];
            for (let i = form?.PaxRooms?.length; i < Number(val); i++) {
                rooms.push({
                    Adults: 1,
                    Children: 0,
                    ChildrenAges: []
                });
            }

            // (1) If the current number of paxRooms exceeds the selected room count, remove the last (paxRoom.length - selectedRoomCount(val)) entries.
            // (2) Add more paxRooms with adult and child info if the current count of paxRooms is less than the selected room count.

            const newPaxRooms = form?.PaxRooms?.length > Number(val) ?
                form?.PaxRooms?.slice(0, Number(val) - form?.PaxRooms?.length)
                :
                [...form?.PaxRooms, ...rooms];

            setTotalNoOfRooms(Number(val));
            setForm((prevForm) => ({
                ...prevForm,
                // Filters: {
                //     ...prevForm?.Filters,
                //     NoOfRooms: Number(val)
                // },
                PaxRooms: newPaxRooms
            }))

        }
        else if (name === "Adults") {
            setForm((prevForm) => ({
                ...prevForm,
                PaxRooms: prevForm?.PaxRooms?.map((room, index) =>
                    index === roomindex
                        ? { ...room, Adults: Number(val) }
                        : room
                )
            }));
        }
        else if (name === "Children") {

            let ChildrenAgesLength = 0
            form?.PaxRooms?.forEach((room, index) => {
                if (index === roomindex) {
                    ChildrenAgesLength = room?.ChildrenAges?.length
                }
            });

            let ages = [];
            for (let i = ChildrenAgesLength; i < Number(val); i++) {
                ages?.push(0);
            }
            form?.PaxRooms?.map((room, index) =>
                index === roomindex
                    ? {
                        ...room,
                        Children: Number(val),
                        ChildrenAges: room?.ChildrenAges?.length > Number(val) ?
                            room.ChildrenAges?.slice(0, Number(val) - room?.ChildrenAges?.length)
                            : [...room?.ChildrenAges, ...ages]
                    }
                    : room
            )

            setForm((prevForm) => ({
                ...prevForm,
                PaxRooms: prevForm?.PaxRooms?.map((room, index) =>
                    index === roomindex
                        ? {
                            ...room,
                            Children: Number(val),
                            ChildrenAges: room?.ChildrenAges?.length > Number(val) ?
                                room.ChildrenAges?.slice(0, Number(val) - room?.ChildrenAges?.length)
                                : [...room?.ChildrenAges, ...ages]
                        }
                        : room
                )
            }));
        }
        else if (name === "ChildrenAges") {
            setForm((prevForm) => {
                const updatedChildrenAges = [...prevForm.PaxRooms[roomindex].ChildrenAges];
                updatedChildrenAges[ageindex] = Number(val);
                return {
                    ...prevForm,
                    PaxRooms: prevForm?.PaxRooms?.map((room, index) =>
                        index === roomindex
                            ? { ...room, ChildrenAges: updatedChildrenAges }
                            : room
                    )
                };
            });
        }
    }

    const hendleDeleteRoom = (e) => {
        e.stopPropagation();
        setForm(prevForm => ({
            ...prevForm,
            PaxRooms: prevForm?.PaxRooms?.slice(0, -1),
            // Filters: {
            //     ...prevForm?.Filters,
            //     NoOfRooms: form?.Filters?.NoOfRooms - 1
            // },
        }));
        setTotalNoOfRooms((prev) => prev - 1);
    }

    const data = () => {
        const roomsWithZeroAge = form?.PaxRooms?.map((room, roomIndex) => {
            const zeroIndexes = room.ChildrenAges
                ?.map((age, childIndex) => (age === 0 ? childIndex : -1))
                ?.filter(index => index !== -1);

            return zeroIndexes?.length > 0 ? { roomIndex, zeroIndexes } : null;
        })?.filter(room => room !== null);
        return (roomsWithZeroAge);
    }

    const valid = () => {
        let errorMessages = {};
        let isError = true
        if (form?.CityCode === 0 && (form?.HotelCodes ? form?.HotelCodes?.trim()?.length === 0 : true)) {
            errorMessages['CityName'] = 'Please select location.'
            isError = false
        }
        if (form?.CheckIn === null) {
            errorMessages['CheckIn'] = 'Please select your check-in date.'
            isError = false
        }
        if (form?.CheckOut === null) {
            errorMessages['CheckOut'] = 'Please select your check-out date.'
            isError = false
        }
        let val = data()
        if (val?.length > 0) {
            errorMessages['Children'] = 'Please select children age.'
            errorMessages['ChildrenAges'] = 'Please select age.'
            errorMessages["age"] = val
            isError = false
        }
        setFormError(errorMessages);
        return isError;
    }

    const createSearchUrl = (data) => {
        const urlParams = new URLSearchParams(location?.pathname !== `/hotel-list` ? '' : searchParams);
        Object.entries(data).forEach((val) => {
            if (searchParams.get(val[0])) {
                urlParams?.delete(val[0]);
            }

            let keys = ["CheckIn", "CheckOut", "CityCode", "HotelCodes", "CityName", "GuestNationality"];
            if (keys.includes(val[0])) {
                if (val[0] === "CityCode" && data?.isHotel) {
                    val[0] = "HotelCodes";
                }
                if (val[0] === "CityName" && data?.isHotel) {
                    val[0] = "HotelName";
                }
                val[1] && urlParams.set(val[0], val[1]);
            }
        })

        data?.PaxRooms?.forEach((room, index) => {
            urlParams.set(`roomReq${index + 1}`, `${index + 1}`);
            urlParams.set(`roomReq${index + 1}noOfAdult`, `${room.Adults}`);
            urlParams.set(`roomReq${index + 1}noOfChildren`, `${room.Children}`);
            room?.ChildrenAges?.forEach((age, ageIndex) => {
                urlParams.set(`roomReq${index + 1}childrenAge${ageIndex + 1}`, `${age}`);
            });
        });
        urlParams.set('isExplore', true)
        return urlParams
    }

    const OnExplore = () => {
        errorclear();
        if (valid()) {
            localStorage.setItem('htlmax', encryptUrlDatapattern(0));
            localStorage.setItem('htlmin', encryptUrlDatapattern(0));
            if (location?.pathname !== `/hotel/search`) {
                const urlPartg = `/hotel/search`
                const newSearch = `?${createSearchUrl(form)?.toString()}`;
                navigate({ pathname: urlPartg, search: newSearch });
            } else {
                setSearchParams(createSearchUrl(form))
            }
        }
    }

    const errorclear = () => {
        if (formError) {
            setTimeout(() => {
                setFormError({})
            }, 5000);
        }
    }

    const hendledate = (checkin, checkout) => {
        setForm({ ...form, CheckIn: checkin === "" ? null : checkin, CheckOut: checkout === "" ? null : checkout })
        //setForm({ ...form, [name]: val === "" ? null : val, CheckOut: val === "" ? next1Date(next1Date(new Date())) : next1Date(val) > form?.CheckOut ? next1Date(val) : form?.CheckOut })
    }

    const handleSuggestionClick = (data) => {
        setFormError({});
        if (data?.isHotel) {
            setForm({ ...form, [data?.name]: data?.CityName, CityCode: 0, HotelCodes: (data?.CityCode)?.toString(), isHotel: data?.isHotel })
        }
        else {
            setForm({ ...form, [data?.name]: data?.CityName, CityCode: Number(data?.CityCode), HotelCodes: '', isHotel: data?.isHotel })
        }
    }

    function next1Date(date) {
        const d = new Date(date);
        d.setDate(d.getDate() + 1);

        let month = (d.getMonth() + 1).toString(),
            day = '' + Number(d.getDate())?.toString(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return date === null ? null : [year, month, day].join('-');
    }

    const transformObject = (obj) => {
        const paxRooms = [];
        let roomId = 1;
        while (obj[`roomReq${roomId}noOfAdult`] !== undefined) {
            const adultsKey = `roomReq${roomId}noOfAdult`;
            const childrenKey = `roomReq${roomId}noOfChildren`;
            const childrenAgesKey = `roomReq${roomId}childrenAge`;

            let adults = obj[adultsKey] || 0;
            let children = obj[childrenKey] || 0;
            let childrenAges = [];

            if (children > 0) {
                for (let j = 1; j <= children; j++) {
                    const childAge = obj[`${childrenAgesKey}${j}`];
                    if (childAge) {
                        childrenAges.push(Number(childAge));
                    }
                }
            }

            paxRooms?.push({
                "Adults": Number(adults),
                "Children": Number(children),
                "ChildrenAges": childrenAges.length > 0 ? childrenAges : []
            });

            roomId++;
        }

        return {
            "CheckIn": obj.CheckIn,
            "CheckOut": obj.CheckOut,
            "HotelCodes": obj.HotelCodes,
            "GuestNationality": obj.GuestNationality,
            "PaxRooms": paxRooms,
            "ResponseTime": HotelResponseTime,
            "IsDetailedResponse": true,
            "Filters": {
                "Refundable": false,
                "NoOfRooms": 0,
                "MealType": 0,
                "OrderBy": 0,
                "StarRating": 0,
                "HotelName": null
            },
            "CityCode": Number(obj.CityCode) ? Number(obj.CityCode) : 0,
            "CityName": obj?.CityName ? obj?.CityName : obj?.HotelName,
            "UserRating": [],
            "Amenities": [],
            "Price": 0
        };
    }

    useMemo(() => {
        const filterFromUrl = {};
        if (searchParams.size > 0) {
            const queryObject = Object?.fromEntries(searchParams?.entries());
            Object?.entries(queryObject)?.forEach(([key, value]) => {
                if (key === "CityCode" || key === "HotelCodes") {
                    filterFromUrl[key] = Number(value);
                } else {
                    filterFromUrl[key] = value ? value : [];
                }
            });
            let paxobj = transformObject(queryObject)
            setForm(paxobj)
        }
    }, [])


    useEffect(() => {
        setForm((prevForm) => ({
            ...prevForm,
            CheckIn: searchParams?.get('CheckIn') ? searchParams?.get('CheckIn') : next1Date(new Date()),
            CheckOut: searchParams?.get('CheckOut') ? searchParams?.get('CheckOut') : next1Date(next1Date(new Date()))
        }));
    }, [])

    const handleOutsideClick = (e) => {
        if (e?.target?.id !== "CheckIn" && e?.target?.id !== "CheckOut" && e?.target?.id !== "checkin" && e?.target?.id !== "checkout") {
            setCalendarOpen(false)
        }
    }

    const handleDone = (e) => {
        const ele = document?.querySelector('.person')
        ele?.classList?.remove("active")
    }

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        if (form?.CheckOut) {
            setCalendarOpen(false)
        }
    }, [form?.CheckOut])

    return (
        <div className="hotelFilter">
            <div className="mainFilter row g-2">
                <div className="col-xl-3 col-lg-3 col-md-6 pr newautocomplete">
                    <AutoComplete
                        options={
                            form?.CityName?.length >= 3 ?
                                homeData?.map((suggestion) => ({
                                    key: suggestion?.CityCode,
                                    label: suggestion?.CityName,
                                    value: (suggestion?.CityCode)?.toString(),
                                    CityCode: suggestion?.CityCode,
                                    isHotel: suggestion?.isHotel,
                                }))
                                : []
                        }
                        onSelect={(value, option) => {
                            handleSuggestionClick({
                                name: 'CityName',
                                CityName: option.label,
                                CityCode: value,
                                isHotel: option.isHotel,
                            })
                        }}
                        value={form?.CityName || ''}
                        autoComplete="off"
                        variant="borderless"
                        className='w-100 h-auto'
                        rootClassName='custom-autocomplete-dropdown'
                    >
                        <div className="form-floating">
                            <input type="text"
                                className="form-control"
                                id="cityLocationOrProperty"
                                placeholder="City, Location Or Property"
                                name='CityName'
                                onChange={(e) => handleChange('CityName', e?.target?.value)}
                                value={form?.CityName}
                                autoComplete='off'
                                disabled={isdisabled ? true : false}
                            />
                            <label htmlFor="cityLocationOrProperty">City Location or Hotel</label>
                            {formError?.CityName && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.CityName}</small>}
                        </div>
                    </AutoComplete>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div className="form-floating position-relative">
                        <input type="text"
                            className="form-control cursor-pointer"
                            id="CheckIn"
                            onClick={() => setCalendarOpen(true)}
                            name='CheckIn'
                            value={form?.CheckIn ? formatDateddmmyyy(form?.CheckIn, '-') : ''}
                            onFocus={() => setFocusedInput('startDate')}
                            readOnly
                            disabled={isdisabled ? true : false}
                            placeholder="Check In" />
                        <label htmlFor="CheckIn">Check In </label>
                        <span className="position-absolute return_flight_calendar cursor-pointer">
                            <i id='checkin' onClick={() => setCalendarOpen(true)} className="fa fa-calendar" aria-hidden="true"></i>
                        </span>
                        {formError?.CheckIn && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.CheckIn}</small>}
                    </div>

                    {/* Hidden calendar popup */}
                    {calendarOpen && (
                        <div className={`${window?.innerWidth < 768 ? 'reactdates_cal' : ''}`} style={{ position: 'absolute', zIndex: 999 }}>
                            <DayPickerRangeController
                                startDate={form?.CheckIn ? moment(new Date(form?.CheckIn)) : null}
                                endDate={form?.CheckOut ? moment(new Date(form?.CheckOut)) : null}
                                onDatesChange={({ startDate, endDate }) => {
                                    hendledate(formatDateyyyymmdd((startDate?._d ? startDate?._d : null), '-'), formatDateyyyymmdd((endDate?._d ? endDate?._d : null), '-'));
                                }}
                                focusedInput={focusedInput}
                                onFocusChange={(input) => setFocusedInput(input || 'startDate')}
                                numberOfMonths={window?.innerWidth < 768 ? 1 : 2}
                                withPortal={window?.innerWidth < 1001 ? true : false}
                                hideKeyboardShortcutsPanel={true}
                                showClearDates={true}
                                isOutsideRange={day => day.isBefore(moment(), 'day')}
                            />
                        </div>
                    )}
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div className="form-floating position-relative"
                        onClick={() => setCalendarOpen(true)}>
                        <input type="text"
                            className="form-control cursor-pointer"
                            id="CheckOut"
                            name='CheckOut'
                            value={form?.CheckOut ? formatDateddmmyyy(form?.CheckOut, '-') : ''}
                            onFocus={() => setFocusedInput('endDate')}
                            readOnly
                            disabled={isdisabled ? true : false}
                            placeholder="Check Out" />
                        <label htmlFor="checkOut">Check Out</label>
                        <span className="position-absolute return_flight_calendar cursor-pointer">
                            <i id='checkout' onClick={() => setCalendarOpen(true)} className="fa fa-calendar" aria-hidden="true"></i>
                        </span>
                        {formError?.CheckOut && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.CheckOut}</small>}
                    </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                    <CustomDropDown
                        title={
                            <div>
                                <i className="fa-solid fa-user-group"></i>
                                &nbsp;<span>{form?.PaxRooms?.length}&nbsp;{form?.PaxRooms?.length > 1 ? 'Rooms' : 'Room'}</span>
                                &nbsp;&amp;
                                &nbsp;<span>{form?.PaxRooms?.reduce((sum, entry) => sum + entry?.Adults, 0)}&nbsp;{form?.PaxRooms?.reduce((sum, entry) => sum + entry?.Adults, 0) > 1 ? 'Adults' : 'Adult'}</span>
                                &nbsp;{(form?.PaxRooms?.reduce((sum, entry) => sum + entry?.Children, 0) > 0) && <span>{form?.PaxRooms?.reduce((sum, entry) => sum + entry?.Children, 0)}&nbsp;{form?.PaxRooms?.reduce((sum, entry) => sum + entry?.Children, 0) > 1 ? 'Children' : 'Child'}</span>}
                            </div>
                        }
                        id={'person-id'}
                        className={'person'}
                    >
                        <div className="passengersRow">
                            <p className="dflex-center">No. of Rooms</p>
                            <div className="counter">
                                <div className="form-floating mb-3 w100">
                                    <select disabled={isdisabled ? true : false} onChange={(e) => onChange("NoOfRooms", e.target.value)} value={totalNoOfRooms} className="form-select" id="NoOfRooms" aria-label="Title">
                                        <option value="1">1 Room</option>
                                        <option value="2">2 Rooms</option>
                                        <option value="3">3 Rooms</option>
                                        <option value="4">4 Rooms</option>
                                        <option value="5">5 Rooms</option>
                                        <option value="6">6 Rooms</option>
                                    </select>
                                    <label htmlFor="NoOfRooms" className={`${isdisabled ? 'bg-color-disable' : ''}`}>No. Of Rooms</label>
                                </div>
                            </div>
                        </div>
                        {form?.PaxRooms?.map((ele, index) => (
                            <Fragment key={index}>
                                <div className="passengersRow">
                                    <p className="dflex-center">Room {index + 1}</p>
                                    <div className="counter">
                                        <div className="form-floating mb-3 w50">
                                            <select disabled={isdisabled ? true : false} className="form-select" onChange={(e) => onChange("Adults", e.target.value, index)} value={ele?.Adults} id="Adults" aria-label="Title">
                                                <option value="1">1 Adult</option>
                                                <option value="2">2 Adults</option>
                                                <option value="3">3 Adults</option>
                                                <option value="4">4 Adults</option>
                                                <option value="5">5 Adults</option>
                                                <option value="6">6 Adults</option>
                                                <option value="7">7 Adults</option>
                                                <option value="8">8 Adults</option>
                                            </select>
                                            <label htmlFor="Adults" className={`${isdisabled ? 'bg-color-disable' : ''}`}>Select Adults</label>
                                        </div>
                                        <div className="form-floating mb-3 w50">
                                            <select disabled={isdisabled ? true : false} className="form-select" onChange={(e) => onChange("Children", e.target.value, index)} value={ele?.Children} id="Children" aria-label="Title">
                                                <option value="0">Select</option>
                                                <option value="1">1 Child</option>
                                                <option value="2">2 Children</option>
                                                <option value="3">3 Children</option>
                                                <option value="4">4 Children</option>
                                            </select>
                                            <label htmlFor="Children" className={`${isdisabled ? 'bg-color-disable' : ''}`}>Select Children</label>
                                        </div>
                                        {(!isdisabled ? true : false) && ((((form?.PaxRooms?.length - 1) === index) && form?.PaxRooms?.length > 1) && <span className="delete" onClick={(e) => hendleDeleteRoom(e)}><i className="fa-solid fa-trash-can"></i></span>)}
                                    </div>
                                </div>
                                <div className="passengersRow flex-column">
                                    {ele?.ChildrenAges?.map((el, ind) => (
                                        <div className='w-100' key={ind}>
                                            <div className="counter float-end">
                                                <p className="dflex-center w50">Child {ind + 1}</p>
                                                <div className="form-floating mb-3 w50">
                                                    <select disabled={isdisabled ? true : false} className="form-select" onChange={(e) => onChange("ChildrenAges", e.target.value, index, ind)} value={el} id="ChildrenAges" aria-label="Title">
                                                        <option value="0">Select</option>
                                                        <option value="1">1 Year</option>
                                                        <option value="2">2 Years</option>
                                                        <option value="3">3 Years</option>
                                                        <option value="4">4 Years</option>
                                                        <option value="5">5 Years</option>
                                                        <option value="6">6 Years</option>
                                                        <option value="7">7 Years</option>
                                                        <option value="8">8 Years</option>
                                                        <option value="9">9 Years</option>
                                                        <option value="10">10 Years</option>
                                                        <option value="11">11 Years</option>
                                                        <option value="12">12 Years</option>
                                                    </select>
                                                    <label htmlFor="chindOneAge" className={`${isdisabled ? 'bg-color-disable' : ''}`}>Select Age</label>
                                                    {(formError?.ChildrenAges && (formError?.age?.filter((room) => room?.roomIndex === index) && formError?.age?.find((room) => room?.roomIndex === index)?.zeroIndexes?.includes(ind))) && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.ChildrenAges}</small>}
                                                </div>
                                                {/* {(((form?.PaxRooms?.length - 1) === index) && (ele?.ChildrenAges?.length - 1) === ind) && <span className="delete" onClick={() => hendleDeleteRoom()}><i className="fa-solid fa-trash-can"></i></span>} */}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Fragment>
                        ))}

                        <button type="button" id='doneRoomSelect' className="btn doneBtn" style={{ width: 'auto', minHeight: 'auto', justifySelf: 'end' }} onClick={(e) => handleDone(e)} > Done </button>
                    </CustomDropDown>
                    {formError?.Children && <small className="text-danger from_flight_error position-absolute ms-4 px-2 bg-body rounded-pill">{formError?.Children}</small>}
                </div>
                <button type="button" className="btn searchBtn" onClick={() => OnExplore()}>{isdisabled ? 'Modify' : 'Explore'}</button>
            </div>
        </div>
    )
}

export default FilterFormHotels